import React from 'react';
import Head from 'next/head';

// Utils
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useTranslation } from 'next-i18next';

import styles from '../../styles/pages/SimplePage.module.scss';

function PagePrivacy() {
  const { t } = useTranslation(['privacy']);

  const getContentHtml = (key) => <div dangerouslySetInnerHTML={{ __html: t(key) }} />;

  return (
    <>
      <Head>
        <title>
          {t('privacyPolicy.title')}
        </title>
      </Head>
      <div className={styles.simple_page}>
        <h1>{t('privacyPolicy.title')}</h1>

        <h2>{t('privacyPolicy.about.title')}</h2>
        {getContentHtml('privacyPolicy.about.text')}

        <h2>{t('privacyPolicy.useDataCollected.title')}</h2>
        <h3>{t('privacyPolicy.useDataCollected.cookies.title')}</h3>
        {getContentHtml('privacyPolicy.useDataCollected.cookies.text')}

        <table>
          <thead>
            <tr>
              <th>{t('privacyPolicy.useDataCollected.cookies.table.head.name')}</th>
              <th>{t('privacyPolicy.useDataCollected.cookies.table.head.purpose')}</th>
              <th>{t('privacyPolicy.useDataCollected.cookies.table.head.duration')}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
              <td
                dangerouslySetInnerHTML={{ __html: t('privacyPolicy.useDataCollected.cookies.table.sessionId.name') }}
                className="ws-nowrap"
              />
              {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
              <td
                dangerouslySetInnerHTML={{
                  __html: t('privacyPolicy.useDataCollected.cookies.table.sessionId.purpose'),
                }}
              />
              {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
              <td
                dangerouslySetInnerHTML={{
                  __html: t('privacyPolicy.useDataCollected.cookies.table.sessionId.duration'),
                }}
              />
            </tr>
            <tr>
              {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
              <td
                dangerouslySetInnerHTML={{
                  __html: t('privacyPolicy.useDataCollected.cookies.table.quantcast.name'),
                }}
                className="ws-nowrap"
              />
              {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
              <td
                dangerouslySetInnerHTML={{
                  __html: t('privacyPolicy.useDataCollected.cookies.table.quantcast.purpose'),
                }}
              />
              {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
              <td
                dangerouslySetInnerHTML={{
                  __html: t('privacyPolicy.useDataCollected.cookies.table.quantcast.duration'),
                }}
              />
            </tr>
            <tr>
              {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
              <td
                dangerouslySetInnerHTML={{ __html: t('privacyPolicy.useDataCollected.cookies.table.stripe.name') }}
                className="ws-nowrap"
              />
              {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
              <td
                dangerouslySetInnerHTML={{ __html: t('privacyPolicy.useDataCollected.cookies.table.stripe.purpose') }}
              />
              {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
              <td
                dangerouslySetInnerHTML={{ __html: t('privacyPolicy.useDataCollected.cookies.table.stripe.duration') }}
              />
            </tr>
            <tr>
              {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
              <td
                dangerouslySetInnerHTML={{ __html: t('privacyPolicy.useDataCollected.cookies.table.ga.name') }}
                className="ws-nowrap"
              />
              {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
              <td
                dangerouslySetInnerHTML={{ __html: t('privacyPolicy.useDataCollected.cookies.table.ga.purpose') }}
              />
              {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
              <td
                dangerouslySetInnerHTML={{ __html: t('privacyPolicy.useDataCollected.cookies.table.ga.duration') }}
              />
            </tr>
            <tr>
              {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
              <td
                dangerouslySetInnerHTML={{ __html: t('privacyPolicy.useDataCollected.cookies.table.gid.name') }}
                className="ws-nowrap"
              />
              {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
              <td
                dangerouslySetInnerHTML={{ __html: t('privacyPolicy.useDataCollected.cookies.table.gid.purpose') }}
              />
              {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
              <td
                dangerouslySetInnerHTML={{ __html: t('privacyPolicy.useDataCollected.cookies.table.gid.duration') }}
              />
            </tr>
            <tr>
              {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
              <td
                dangerouslySetInnerHTML={{ __html: t('privacyPolicy.useDataCollected.cookies.table.gat.name') }}
                className="ws-nowrap"
              />
              {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
              <td
                dangerouslySetInnerHTML={{ __html: t('privacyPolicy.useDataCollected.cookies.table.gat.purpose') }}
              />
              {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
              <td
                dangerouslySetInnerHTML={{ __html: t('privacyPolicy.useDataCollected.cookies.table.gat.duration') }}
              />
            </tr>
          </tbody>
        </table>

        <h2>{t('privacyPolicy.statisticsAudienceMeasurement.title')}</h2>
        {getContentHtml('privacyPolicy.statisticsAudienceMeasurement.text')}

        <h2>{t('privacyPolicy.personalDataCollected.title')}</h2>
        {getContentHtml('privacyPolicy.personalDataCollected.text')}

        <h2>{t('privacyPolicy.personInCharge.title')}</h2>
        {getContentHtml('privacyPolicy.personInCharge.text')}

        <h2>{t('privacyPolicy.processingPurpose.title')}</h2>
        {getContentHtml('privacyPolicy.processingPurpose.text')}

        <h2>{t('privacyPolicy.personalDataRecipients.title')}</h2>
        {getContentHtml('privacyPolicy.personalDataRecipients.text')}

        <h2>{t('privacyPolicy.personalDataRetention.title')}</h2>
        {getContentHtml('privacyPolicy.personalDataRetention.text')}

        <h2>{t('privacyPolicy.security.title')}</h2>
        {getContentHtml('privacyPolicy.security.text')}

        <h2>{t('privacyPolicy.usersRights.title')}</h2>
        {getContentHtml('privacyPolicy.usersRights.text')}

        <h2>{t('privacyPolicy.confidentiality.title')}</h2>
        {getContentHtml('privacyPolicy.confidentiality.text')}
      </div>
    </>
  );
}

export async function getServerSideProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(
        locale || 'fr',
        ['privacy', 'common'],
      )),
    },
  };
}

export default PagePrivacy;
